<!-- Loading state -->
<div *ngIf="activity_loading" class="loading-state">
  <loading message="Loading user activity..."></loading>
</div>

<!-- Error state -->
<div *ngIf="activity_error && !activity_loading" class="error-state">
  <div class="error-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  </div>
  <div class="error-message">Failed to load user activity</div>
  <button class="btn btn-primary" (click)="getUserActivity(userId)">Try Again</button>
</div>

<!-- Activity list content -->
<div *ngIf="!activity_loading && !activity_error" class="list-container">
  <div *ngIf="activity && activity.length > 0; else noActivity">
    <div *ngFor="let item of activity" class="list-item">
      <div class="item-details">
        <span class="item-name">{{ item.ENDPOINT_PATH }}</span>
        <span class="item-subtitle">{{ item.HTTP_METHOD }} - {{ item.TIMESTAMP_NTZ | date:'short' }}</span>
      </div>
    </div>
  </div>
  <ng-template #noActivity>
    <div class="list-item">
      <div class="item-details">
        <span class="item-name">No activity found for this user.</span>
      </div>
    </div>
  </ng-template>
</div>
